import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import { media } from "@atlaskit/primitives/responsive";
import UFOSegment from "@atlaskit/react-ufo/segment";

import { Picture } from "@/components/wpl/image/src";
import { Link } from "@/libraries/design/components";
import { useLocalizedHref } from "@/libraries/web-framework";
import { Row } from "@/libraries/wpl/foundations/src";

export const DataCenterSection = () => {
    const intl = useIntl();

    const dataCenterSectionContent = {
        headerText: intl.formatMessage({
            id: "EnterpriseLandingPage.DataCenterSection.headerText",
            defaultMessage: "Not ready to move to cloud?"
        }),
        bodyText: intl.formatMessage({
            id: "EnterpriseLandingPage.DataCenterSection.bodyText",
            defaultMessage:
                "Atlassian Data Center is our self-managed, enterprise-grade offering designed for organizations with strict security and compliance requirements."
        }),
        linkText: intl.formatMessage({
            id: "EnterpriseLandingPage.DataCenterSection.linkText",
            defaultMessage: "Learn about Data Center"
        }),
        href: useLocalizedHref("/enterprise/data-center")
    };

    return (
        <UFOSegment name="enterprise-page-dataCenter">
            <section css={dataCenterSectionContainerStyle}>
                <Row layout="12">
                    <div className="data-center-container">
                        <div className="img-container">
                            <Picture
                                image={{
                                    src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/enterprise-data-center-icon-3736035258.webp",
                                    alt: ""
                                }}
                            />
                        </div>
                        <div className="text-container">
                            <h4>{dataCenterSectionContent.headerText}</h4>
                            <p>{dataCenterSectionContent.bodyText}</p>
                            <Link
                                href={dataCenterSectionContent.href}
                                text={dataCenterSectionContent.linkText}
                                type="primary"
                                dataEventProps={{
                                    "data-label":
                                        dataCenterSectionContent.linkText,
                                    "data-product-key": "enterprise",
                                    "data-event-component": "linkButton",
                                    "data-event-container": "dataCenterSection",
                                    "data-event": "clicked",
                                    "data-label-english":
                                        "Learn about Data Center"
                                }}
                            />
                        </div>
                    </div>
                </Row>
            </section>
        </UFOSegment>
    );
};

const dataCenterSectionContainerStyle = css({
    "backgroundColor": "#F0F1F2",
    "padding": "80px 0",
    // Reason: Tech Debt - Disable needed to migrate from wac-ufo-segment to ufo-segment
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    ".row-layout": {
        "width": "85%",
        "padding": "24px 32px",
        "maxWidth": "1275px",
        "background": "#DFE1E6",
        "borderRadius": "20px",
        // Reason: Tech Debt - Disable needed to migrate from wac-ufo-segment to ufo-segment
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        ".data-center-container": {
            "display": "flex",
            "flexWrap": "nowrap",
            "flexDirection": "row",
            // Reason: Tech Debt - Disable needed to migrate from wac-ufo-segment to ufo-segment
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            ".img-container": {
                width: "218px",
                height: "86px",
                display: "flex",
                flexBasis: "20%",
                alignItems: "center",
                alignSelf: "flex-start",
                // Reason: Tech Debt - Disable needed to migrate from wac-ufo-segment to ufo-segment
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                img: {
                    width: "218px",
                    height: "218px"
                }
            },
            // Reason: Tech Debt - Disable needed to migrate from wac-ufo-segment to ufo-segment
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            ".text-container": {
                "display": "flex",
                "flexWrap": "wrap",
                "flexBasis": "80%",
                "alignContent": "flex-start",
                "marginInlineStart": "32px",
                "maxWidth": "700px",
                // Reason: Tech Debt - Disable needed to migrate from wac-ufo-segment to ufo-segment
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                "h4": {
                    margin: "0",
                    marginBlockEnd: "8px",
                    height: "30px"
                },
                // Reason: Tech Debt - Disable needed to migrate from wac-ufo-segment to ufo-segment
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                "p": {
                    margin: "0",
                    maxWidth: "600px",
                    marginBlockEnd: "8px"
                },
                // Reason: Tech Debt - Disable needed to migrate from wac-ufo-segment to ufo-segment
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                ".link-wrapper": {
                    display: "flex",
                    flexBasis: "100%",
                    // Reason: Tech Debt - Disable needed to migrate from wac-ufo-segment to ufo-segment
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                    a: {
                        fontSize: "1rem",
                        lineHeight: "1.5rem",
                        fontWeight: 500
                    }
                }
            }
        }
    },

    [media.below.md]: {
        // Reason: Tech Debt - Disable needed to migrate from wac-ufo-segment to ufo-segment
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        ".row-layout": {
            "padding": "32px",
            // Reason: Tech Debt - Disable needed to migrate from wac-ufo-segment to ufo-segment
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            ".data-center-container": {
                "flexWrap": "wrap",
                "justifyContent": "center",
                // Reason: Tech Debt - Disable needed to migrate from wac-ufo-segment to ufo-segment
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                ".img-container": {
                    flexBasis: "100%",
                    justifyContent: "center",
                    alignItems: "flex-end",
                    marginBlockEnd: "32px",
                    // Reason: Tech Debt - Disable needed to migrate from wac-ufo-segment to ufo-segment
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                    img: {
                        height: "168px",
                        width: "168px"
                    }
                },
                // Reason: Tech Debt - Disable needed to migrate from wac-ufo-segment to ufo-segment
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                ".text-container": {
                    "display": "flex",
                    "flexWrap": "wrap",
                    "flexBasis": "100%",
                    "textAlign": "center",
                    "margin": "0",
                    "justifyContent": "center",
                    // Reason: Tech Debt - Disable needed to migrate from wac-ufo-segment to ufo-segment
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                    "h4": {
                        fontSize: "24px",
                        margin: "0 0 12px 0",
                        height: "auto"
                    },
                    // Reason: Tech Debt - Disable needed to migrate from wac-ufo-segment to ufo-segment
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                    "p": {
                        margin: "0 0 12px 0",
                        flexBasis: "100%",
                        maxWidth: "none"
                    },
                    // Reason: Tech Debt - Disable needed to migrate from wac-ufo-segment to ufo-segment
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                    ".link-wrapper": {
                        display: "flex",
                        justifyContent: "center",
                        flexBasis: "100%"
                    }
                }
            }
        }
    }
});
